import { render, staticRenderFns } from "./TextPerguntasFrequentes.vue?vue&type=template&id=b6b48a2e&scoped=true&"
import script from "./TextPerguntasFrequentes.vue?vue&type=script&lang=js&"
export * from "./TextPerguntasFrequentes.vue?vue&type=script&lang=js&"
import style0 from "./TextPerguntasFrequentes.vue?vue&type=style&index=0&id=b6b48a2e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6b48a2e",
  null
  
)

export default component.exports